<div *ngIf="legacyFreezeFrames">
  <app-xml-code-viewer [titleName]="'Freezframes'" [readModeOnly]="true" [xmlString]=[legacyFreezeFrames.xmlContent]>
  </app-xml-code-viewer>
</div>

<div *ngIf="!legacyFreezeFrames">
  <app-harmonized-freeze-frames></app-harmonized-freeze-frames>
</div>
